import axios from "axios";
//local : 'https://dragonbox.me/api/';
const api = axios.create({
    baseURL:'https://dragonbox.me/api/',
});

export default api;